var images: Record<string, HTMLImageElement> = {};

export const preloadImages = (urls: Array<string>) => {
    for (const url of urls) {
        let image = new Image();
        image.src = url;
        images.url = image;
    }
};
